import React from 'react';
import styled from 'styled-components';
const StyledFieldSet = styled.fieldset({
    border: 0,
});
const StyledLegend = styled.legend({
    position: 'absolute',
    clip: 'rect(0 0 0 0)',
});
const FormGroup = ({ label, children }) => (React.createElement(StyledFieldSet, null,
    React.createElement(StyledLegend, null, label),
    children));
/**
 * @deprecated
 */
export default FormGroup;
